import { ScrimFilter } from "./types";

export const defaultScrimstFilters: ScrimFilter = {
  region: "",
  tier: "",
};
